import React, { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { Tag, UserCheck, Trash2 } from 'lucide-react';
import { useTheme } from '../ThemeContext';

export const ActionNode = memo(({ data, selected }) => {
  const { isDark } = useTheme();
  const actionType = data.actionType || 'ADD_TAG';

  return (
    <div className={`w-72 rounded-xl border transition-all ${
      isDark ? 'bg-slate-900 border-slate-800 shadow-xl' : 'bg-white border-slate-200 shadow-lg'
    } ${
      selected ? 'border-orange-500 ring-2 ring-orange-500/30' : (isDark ? 'hover:border-slate-700' : 'hover:border-slate-300')
    }`}>
      <Handle
        type="target"
        position={Position.Left}
        id="input"
        className={`!h-3.5 !w-3.5 !border-2 !bg-orange-500 hover:!scale-125 transition-transform ${
          isDark ? '!border-slate-900' : '!border-white'
        }`}
      />

      <div className={`flex items-center justify-between rounded-t-xl px-3.5 py-2.5 border-b ${
        isDark
          ? 'bg-gradient-to-r from-orange-950/80 to-orange-900/40 border-orange-500/20'
          : 'bg-gradient-to-r from-orange-50 to-amber-50 border-orange-200'
      }`}>
        <div className="flex items-center gap-2">
          <div className={`flex h-6 w-6 items-center justify-center rounded-lg ${
            isDark ? 'bg-orange-500/20 text-orange-400' : 'bg-orange-100 text-orange-700'
          }`}>
            <Tag className="h-3.5 w-3.5" />
          </div>
          <span className={`text-xs font-bold uppercase tracking-wider ${
            isDark ? 'text-orange-200' : 'text-orange-900'
          }`}>
            {data.label || 'CRM Action'}
          </span>
        </div>
        <span className={`rounded px-1.5 py-0.5 text-[10px] font-medium ${
          isDark ? 'bg-orange-500/10 text-orange-300' : 'bg-orange-100 text-orange-700'
        }`}>
          ACTION
        </span>
      </div>

      <div className={`p-3.5 text-xs space-y-1.5 ${isDark ? 'text-slate-300' : 'text-slate-700'}`}>
        <div className={`flex items-center gap-1.5 ${isDark ? 'text-slate-400' : 'text-slate-500'}`}>
          {actionType === 'ADD_TAG' && <UserCheck className="h-3.5 w-3.5 text-emerald-500" />}
          {actionType === 'REMOVE_TAG' && <Trash2 className="h-3.5 w-3.5 text-rose-500" />}
          <span>{actionType === 'ADD_TAG' ? 'Add CRM Tag:' : 'Remove Tag:'}</span>
        </div>
        <div className={`inline-flex items-center gap-1.5 rounded-md px-2 py-0.5 font-semibold text-xs border ${
          isDark
            ? 'bg-orange-950/40 border-orange-800/40 text-orange-300'
            : 'bg-orange-50 border-orange-200 text-orange-800'
        }`}>
          <Tag className="h-3 w-3 text-orange-400" />
          <span>{data.tag || '(No Tag set)'}</span>
        </div>
      </div>

      <Handle
        type="source"
        position={Position.Right}
        id="output"
        className={`!h-3.5 !w-3.5 !border-2 !bg-orange-500 hover:!scale-125 transition-transform ${
          isDark ? '!border-slate-900' : '!border-white'
        }`}
      />
    </div>
  );
});
